/* global L, mo, helper, emoji */

$(function(){
    mod_tickets.$count = $('#top_panel .mess .count');
    mod_tickets.$contextmenu = $('#contextmenu_mess');
    mod_tickets.$win_add = $('#tickets_add');
    mod_tickets.$win_edit = $('#tickets_edit');
    mod_tickets.$win_add_edit = mod_tickets.$win_add.add(mod_tickets.$win_edit);
    mod_tickets.$win_add_base_message = $('#win_add_message'); // сообщение базе


    $('.add_ticket').click(function(event){
        event.preventDefault();
        let ww = 490;
        if($(window).width() < ww) ww = $(window).width() * 0.9;

        mod_tickets.$win_add.dialog({
            width: ww
        });
    });
});

var mod_tickets = {};

// получить иконку для типпа тикета
mod_tickets.get_ico = function(type){
    var ico;

    switch(type * 1){
        case 2:
            ico = 'icon-at';
            break;
        case 3:
            ico = 'icon-ios-app';
            break;
        case 4:
            ico = 'icon-vk-round';
            break;
        case 5:
            ico = 'icon-chrome';
            break;
        case 6:
            ico = 'icon-twitter-round';
            break;
        case 7:
            ico = 'icon-facebook-round';
            break;
        case 8:
            ico = 'icon-telegram-round';
            break;
        case 12:
            ico = 'icon-android-app';
            break;
        case 0:
        case 1:
        default:
            ico = 'icon-envelope';
            break;
    }

    return ico;
};

// получить ссылку на страницу в соц. сети
mod_tickets.get_social_link = function(row){
    let social_link = '';
    if(row.nickname !== undefined){
        switch(row.network){
            case '4':
                social_link += 'https://vk.com/id' + row.social_user_id;
                break;
            case '6':
                social_link += 'https://twitter.com/' + row.nickname;
                break;
            case '7':
                social_link += 'https://www.facebook.com/' + row.social_user_id;
                break;
        }

        if(row.network != '8') social_link = '<a href="' + social_link + '" target="_blank">' + (row.name ? row.name : row.nickname) + '</a>';
        else social_link = row.name;
    }

    if(!social_link) social_link = '';

    return social_link;
};

// открыть тикет по хеш-тегу
mod_tickets.open_from_hash = function(){
    var ticket_id = mo.getHash('open_ticket');
    if(ticket_id) mod_tickets.open_ticket(ticket_id);

    var create_ticket = mo.getHash('create_ticket');
    if(create_ticket) $('#contextmenu_mess [rel=create]').click();
};

// открыть окно с тикетом
mod_tickets.open_ticket_stop = false;
mod_tickets.open_ticket = function(ticket_id){
    $('body').addClass('no-scroll-mobile');

    if(mod_tickets.open_ticket_stop) return;
    mod_tickets.open_ticket_stop = true;

    mo.setHash('open_ticket', ticket_id);

    let ww = $(window).width(); // ширина окна браузера
    let pw = 750; // ширина попапа
    if(ww <= pw){
        pw = ww * 0.9;
    }
    mod_tickets.$win_edit.dialog({width: pw});
    mod_tickets.$win_edit.data('ticket_id', ticket_id);

    // удалить тикет из списка непрочитанных тикетов в основном баре
    if($('a[rel=' + ticket_id + ']', mod_tickets.$contextmenu).length){
        $('a[rel=' + ticket_id + ']', mod_tickets.$contextmenu).parent().remove();
        let count = mod_tickets.$count.text() * 1 - 1;
        mod_tickets.$count.text(count);
        if(!count) mod_tickets.$count.hide();
    }

    $('.messages', mod_tickets.$win_edit).html('<div id="tickets_admin_writing"></div>');

    mo.preloader(true, $('.messages', mod_tickets.$win_edit));
    mo.get(function(rows){
        mod_tickets.open_ticket_stop = false;
        if(rows.error) return;

        let last_row;
        $.map(rows, function(row, index){
            if(index){ // сообщения
                mod_tickets.open_ticket_insert_message(row, rows[0]);
                last_row = row;
            }else{ // данные тикета
                let ico = mod_tickets.get_ico(row.type);
                $('.modal-header h3', mod_tickets.$win_edit).html('<span class="' + ico + '"></span>');

                $admin_bar = $('.modal-header .admin_bar', mod_tickets.$win_edit);
                if(!$admin_bar.length) $admin_bar = $('<div class="admin_bar flex"></div>').insertAfter($('.modal-header h3', mod_tickets.$win_edit));
                $admin_bar.html('<div class="col lft"></div><div class="col rght"></div>');

                let $cb = $(helper.insertCheckbox('status', '1', L.TICKETS_Close_ticket, (row.status * 1 == 1)));
                $admin_bar.find('.lft').append($cb);

                // сообщение не прочитано
                let no_readed = !(row.answerer_readed * 1);

                // информация о пользовтаеле
                if(row.user_data){
                    no_readed = !(row.owner_readed * 1);
                    mod_tickets.render_admin_bar(row, $admin_bar);
                }

                // привязка задач (redmine)
                if(mo.user.group == 1) mod_tickets.insert_task(row.task_id);

                if(no_readed) $('.messages', mod_tickets.$win_edit).append('<div class="no_readed">' + L.TICKETS_Not_readed + '</div>');

                if(row.status == 1 || (row.type * 1 == 4 && !row.social_user_id) || row.type * 1 == 5) // на тикет ответить нельзя
                    $('.add_form, .task', mod_tickets.$win_edit).hide();
                else // на тикет ответить можно
                    $('.add_form, .task', mod_tickets.$win_edit).show();
            }
        });
        $('.messages', mod_tickets.$win_edit).scrollTop(99999);

        mo.preloader(false, $('.messages', mod_tickets.$win_edit));
    }, 'mod_tickets', 'post', {ticket_id: ticket_id});
};

// вставить пост в окно с тикетом
mod_tickets.open_ticket_insert_message = function(row, ticket_info){
    let html_files = '';
    let html_files_img = '';
    let html_files_file = '';
    if(row.files.length){
        $.map(row.files, function(file){
            if(!file) return;
            let name = file.match(/\/([^/]*?)$/)[1];

            if(/\.(jpg|jpeg|png|gif|bmp)$/.test(file))
                html_files_img += '<div class="files_el"><div class="thumb"><a href="' + file + '" title="' + name + '" target="_blank"><img src="' + file + '"></a></div></div>';
            else
                html_files_file += '<div class="file"><a href="' + file + '" class="name" target="_blank"><span class="icon-file-alt"></span>' + name + '</a></div>';
        });

        html_files += '<div class="files cf">';
        html_files += html_files_img;
        if(html_files_file) html_files += '<div class="files_el">' + html_files_file + '</div>';
        html_files += '</div>';
    }

    let html = '';

    let login = (row.email != row.login && row.email) ? row.login + ' (' + row.email + ')' : row.login;
    social_link = mod_tickets.get_social_link(row);
    if(login && social_link) social_link = ' (' + social_link + ')';
    login += social_link;

    let status = row.online ? L.TICKETS_Online : L.TICKETS_Visited + ': ' + helper.dateInRusFormat(row.lastactive).substr(0, 16);
    if(row.user != -1) login += ' #' + row.user;

    let editable = ((ticket_info.type == 0 || ticket_info.type == 3 || ticket_info.type == 12 || ticket_info.type == 4) && row.is_admin);

    let text = row.text /*emoji.render(row.text)*/;
    text = text.replace(/([^"])(https?:\/\/[\w./]+\.gif)/g, '$1<img src="$2">');

    let $VO = document.createElement('div');// виртуальный объект для редактирования текста
    $VO.innerHTML = text;
    $.map($('a', $VO), function(link, ind){
        $(link).text(mod_tickets.extractHostname($(link).text(), 1));
    });
    text = $($VO).html();
    $VO.remove();

    html += '<div class="el cf ' + (editable ? 'editable' : '') + '">';
    html += '<div class="header">' +
        '<strong>' + login + '</strong> ' +
        '<span class="comment">' + helper.dateInRusFormat(row.time, '.') + '</span>' +
        '</div>';
    html += '<div>' +
        '<div class="avatar" title="' + status + '">' +
        '<div class="status ' + (row.online ? 'online' : 'offline') + '"><i></i></div>' +
        '<img src="' + row.avatar + '" />' +
        '</div>' +
        '<div class="triangle"></div>' +
        '<div class="text">' + text + html_files + '</div>' +
        '</div>';

    if(editable){
        html += '<a href="." class="del icon-remove" data-post_id="' + row.id + '" title="' + L.Delete + '"></a>';
        html += '<a href="." class="save icon-check-on" data-post_id="' + row.id + '" title="' + 'Сохранить' + '"></a>';
    }

    html += '</div>';

    $('.messages', mod_tickets.$win_edit).prepend(html);
};

// ипользуется в турбазе
mod_tickets.gen_bases = function(row){
    if(!row.bases) return '';

    var html = '<div class="bases"><a href="." data-menuPopup-id="mod_tickets_bases" data-p="2" data-notch="1">Базы</a></div>';

    html += '<div class="template" id="mod_tickets_bases"><ul class="content">';
    $.map(row.bases, function(base){
        html += '<li><a href="/extranet/base/' + base.id + '/" target="_blank">' + base.name + '</a></li>';
    });
    html += '</ul></div>';

    return html;
};

mod_tickets.extractHostname = function(url, useEllipsis){
    if(useEllipsis === undefined) useEllipsis = 0;
    var protocol = '';
    var ellipsis = '';
    var hostname;
    //find & remove protocol (http, ftp, etc.) and get hostname
    if(url.indexOf("://") > -1){
        protocol = url.split('/')[0] + '//';
        hostname = url.split('/')[2];
        if(url.split('/')[3] && useEllipsis) ellipsis = '...';
    }
    else{
        hostname = url.split('/')[0];
        if(url.split('/')[1] && useEllipsis) ellipsis = '...';
    }

    //find & remove port number
    hostname = hostname.split(':')[0];
    //find & remove "?"
    hostname = hostname.split('?')[0];

    return protocol + hostname + ellipsis;
};